import { render, staticRenderFns } from "./clientes-lista.vue?vue&type=template&id=69a9ee18"
import script from "./clientes-lista.vue?vue&type=script&lang=js"
export * from "./clientes-lista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports